var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91757 20.219C5.28885 18.6606 2.54688 12.1221 2.54688 8.26694C2.54688 4.2126 5.84891 0.896484 9.88601 0.896484H11.1111C15.1482 0.896484 18.4503 4.2126 18.4503 8.26694C18.4503 12.2275 15.545 19.0355 11.7645 20.3362",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63006 9.521L2.54838 11.2201C2.24501 11.2201 2 11.4661 2 11.7708C2 12.4387 2.3267 13.0715 2.88676 13.4464L3.94854 14.1729",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3693 9.521L18.4509 11.2201C18.7543 11.2201 18.9993 11.4661 18.9993 11.7708C18.9993 12.4387 18.6726 13.0715 18.1126 13.4464L17.0508 14.1729",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56641 9.84891L6.40994 7.84518C6.71331 7.51708 6.91165 7.11868 6.98166 6.67341L7.30836 4.79857C7.37837 4.41188 7.86842 4.30642 8.09011 4.61108L8.86019 5.66568C9.28024 6.23985 9.94531 6.56795 10.6454 6.56795H13.7724C15.1725 6.56795 16.316 7.71628 16.316 9.12241V9.84891",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64761 19.4572C7.64761 19.4572 6.76083 18.1448 7.63593 16.5512C8.69771 14.6061 9.47947 13.1765 10.5062 13.1765",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3664 19.4455C13.3664 19.4455 14.2415 18.1448 13.3664 16.5512C12.3046 14.6061 11.4879 13.1765 10.4961 13.1765",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2978 18.2269C11.2978 18.8363 10.9477 19.1292 10.5044 19.1292C10.061 19.1292 9.71094 18.8363 9.71094 18.2269C9.71094 17.6176 10.2127 16.9263 10.5044 16.9263C10.7961 16.9263 11.2978 17.6176 11.2978 18.2269Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.506 22.0002C10.2726 22.0002 10.0859 21.8127 10.0859 21.5784V19.0122C10.0859 18.7778 10.2726 18.5903 10.506 18.5903C10.7393 18.5903 10.926 18.7778 10.926 19.0122V21.5784C10.926 21.801 10.7393 22.0002 10.506 22.0002Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88458 10.7395C8.88458 11.2319 8.56955 11.6423 7.74113 11.6423C6.93604 11.6423 6.59766 11.2436 6.59766 10.7395",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4041 10.7395C14.4041 11.2319 14.0891 11.6423 13.2606 11.6423C12.4556 11.6423 12.1172 11.2436 12.1172 10.7395",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.cdd692dac38fce7a3e1f88c668b864d9.svg";
export { ForwardRef as ReactComponent };